import { categories } from '@/mocks/categories';
import { useParams, useNavigate } from 'react-router-dom';

interface CategoryTabsProps {
  activeSlug: string;
}

export default function CategoryTabs({ activeSlug }: CategoryTabsProps) {
  const navigate = useNavigate();

  return (
    <div className="py-4 overflow-x-auto">
      <div className="flex items-center gap-2 min-w-max">
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => {
              navigate(`/category/${cat.slug}`);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              activeSlug === cat.slug
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200'
            }`}
          >
            <i className={`${cat.icon} text-sm`}></i>
            {cat.name}
          </button>
        ))}
      </div>
    </div>
  );
}